export enum SecurityTypeEnum {
  OnSite = 'onSite',
  Virtual = 'virtual',
}
